export default __webpack_public_path__ + "static/media/ruFlag.80cad015.svg";